<p-tag [value]="getStatus()" [severity]="getSeverity()"></p-tag>